<ion-content [scrollY]="false">

  <ion-datetime
    #dateTime
    size="cover"
    [firstDayOfWeek]="1"
    [showDefaultButtons]="true"
    [value]="dateValue"
    [presentation]="presentation"
    [min]="min"
    [max]="max"
    [isDateEnabled]="isDateAllowed"
    [minuteValues]="minuteValues"
    (ionChange)="changeDate(dateTime.value)"
  >

    <ion-buttons slot="buttons">
      @if (cancelText) {
        <ion-button (click)="cancel(dateTime)">{{ cancelText | translate }}</ion-button>
      }

      @if (doneText) {
        <ion-button (click)="done(dateTime)">{{ doneText | translate }}</ion-button>
      }
    </ion-buttons>

  </ion-datetime>

</ion-content>
